import React from "react";
import { InvoiceCreateContext } from "./contextProvider";

function useInvoiceCreateContext() {
  const context = React.useContext(InvoiceCreateContext);

  return context;
}

export default useInvoiceCreateContext;
